import type { Balloon } from "../entities/Balloon";
import type { Frisbee } from "../entities/Frisbee";

export function circlesOverlap(
  ax: number,
  ay: number,
  ar: number,
  bx: number,
  by: number,
  br: number,
): boolean {
  const dx = ax - bx;
  const dy = ay - by;
  const r = ar + br;
  return dx * dx + dy * dy <= r * r;
}

export function hitBalloons(frisbee: Frisbee, balloons: Balloon[]): Balloon[] {
  return balloons.filter(
    (balloon) =>
      balloon.hittable && circlesOverlap(frisbee.x, frisbee.y, frisbee.radius, balloon.x, balloon.y, balloon.radius),
  );
}
